module.exports = __webpack_public_path__ + "static/cima-51eebd1d4441e0a12632fb6a2801cdc0.png";